import CustomerOrder from '@/api/restaurant-sale/customer-display-order'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  productCategories: [],
  products: [],
  systemSettings: [],
  promotions: {},
  companyInfo: {},
  tableSelected: {}
}

export const getters = {
  defaultPrice: state => productId => {
    if (productId) {
      return _.ceil(
        state.products
          .filter(p => p.product_id == productId)
          .map(el => el.sale_code)
          .flat()
          .filter(s => s.unit_of_measure.is_default == true)
          .reduce(
            (init, value) => (init = value.product_price.sale_price),
            null
          ),
        2
      )
    }

    return 0
  },
  saleCodeByDefaultUom: state => productId => {
    if (productId) {
      return state.products
        .filter(p => p.product_id == productId)
        .map(el => el.sale_code)
        .flat()
        .filter(s => s.unit_of_measure.is_default == true)
        .reduce((init, value) => (init = value), null)
    }

    return 0
  },
  getUomName: state => (productId, uomId) => {
    if (productId) {
      return state.products
        .filter(p => p.product_id == productId)
        .map(el => el.sale_code)
        .flat()
        .filter(s => s.unit_of_measure.uom_id == uomId)
        .reduce(
          (init, value) => (init = value.unit_of_measure.uom_name_en),
          null
        )
    }

    return null
  },
  getProduct: state => productId => {
    if (productId) {
      return state.products
        .filter(p => p.product_id == productId)
        .reduce((init, value) => (init = value), null)
    }
  },
  getPromotionDiscount: state => productId => {
    if (productId && state.promotions.promotion_discount.length > 0) {
      return state.promotions.promotion_discount
        .filter(d =>
          _.includes(
            d.discount_items.map(el => el.product_id),
            productId
          )
        )
        .reduce((init, value) => {
          let { discount_items, ...rawData } = value
          init = rawData
          return init
        }, null)
    }

    return null
  },
  getPromotionItemFreeItem: state => (productId, uomId, quantity) => {
    if (
      productId &&
      quantity &&
      state.promotions.promotion_buy_item_free_item.length > 0
    ) {
      let free_products = Object.entries(
        ...state.promotions.promotion_buy_item_free_item
      )
        .sort(([, a], [, b]) => a - b)
        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {})
        .free_items.filter(
          p => p.product_buy_id == productId && p.uom_buy_id === uomId
        )
      if (free_products.length > 0) {
        let free_item = Object.entries(...free_products)
          .sort(([, a], [, b]) => a - b)
          .reduce((r, [k, v]) => ({ ...r, [k]: v }), {})
        return free_item.free_item_list.map(el => ({
          product_id: el.product_free_id,
          unit_price: el.price,
          condition_type: free_item.condition_type,
          quantity:
            parseInt(quantity / free_item.buy_quantity) * el.free_quantity,
          uom_id: el.uom_free_id,
          promotions: Object.entries(
            ...state.promotions.promotion_buy_item_free_item
          )
            .sort(([, a], [, b]) => a - b)
            .reduce((r, [k, v]) => ({ ...r, [k]: v }), {})
        }))
      }
    }

    return null
  },
  getPromotionBuyItemFreeItem: state => (productId, uomId) => {
    if (productId && state.promotions.promotion_buy_item_free_item.length > 0) {
      let free_products = Object.entries(
        ...state.promotions.promotion_buy_item_free_item
      )
        .sort(([, a], [, b]) => a - b)
        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {})
        .free_items.filter(
          p => p.product_buy_id == productId && p.uom_buy_id === uomId
        )
      if (free_products.length > 0) {
        let free_item = Object.entries(...free_products)
          .sort(([, a], [, b]) => a - b)
          .reduce((r, [k, v]) => ({ ...r, [k]: v }), {})
        return {
          free_item: free_item,
          promotion_name: Object.entries(
            ...state.promotions.promotion_buy_item_free_item
          )
            .sort(([, a], [, b]) => a - b)
            .reduce((r, [k, v]) => ({ ...r, [k]: v }), {}).promotion_name
        }
      }
    }

    return null
  },
  getPromotionFreeItemPerAmount: state => amount => {
    if (amount && state.promotions.promoion_free_item_per_amount.length > 0) {
      return state.promotions.promoion_free_item_per_amount
        .filter(pa => {
          return (
            pa.conditions.filter(c => {
              if (c.operator_sign == '>=') {
                return amount >= c.amount_from
              } else if (c.operator_sign == '=') {
                return amount == c.amount_from
              } else {
                return _.inRange(amount, c.amount_from, c.amount_to)
              }
            }).length > 0
          )
        })
        .map(el => {
          return Object.assign({}, el, {
            conditions: el.conditions
              .filter(c => {
                if (c.operator_sign == '>=') {
                  return amount >= c.amount_from
                } else if (c.operator_sign == '=') {
                  return amount == c.amount_from
                } else {
                  return _.inRange(amount, c.amount_from, c.amount_to)
                }
              })
              .reduce((init, value) => {
                let { operator_sign, ...rawData } = value
                init = rawData
                return init
              }, null)
          })
        })
        .reduce((init, value) => {
          let { promo_end_date, promo_start_date, ...rawData } = value
          init = rawData
          return init
        }, null)
    }

    return null
  }
}

export const mutations = {
  ...baseMutations,
  SET_PRODUCT_CATEGORY(state, data) {
    state.productCategories = data
  },
  RECEIVE_PRODUCTS(state, data) {
    state.products = data
  },
  SET_SYSTEM_SETTING(state, data) {
    state.systemSettings = data
  },
  SET_PROMOTIONS(state, data) {
    state.promotions = data
  },
  SET_COMPANY(state, data) {
    state.companyInfo = data
  },
  RECEIVE_TABLE_SELECTED(state, data) {
    state.tableSelected = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search
        }
      },
      attrubutes
    )
    return CustomerOrder.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return CustomerOrder.store(data)
  },
  async fetchBefore(context) {
    if (!context.state.productCategories.length > 0) {
      let category = await CustomerOrder.category()
      context.commit('SET_PRODUCT_CATEGORY', category.data)
    }
    if (_.isEmpty(context.state.systemSettings)) {
      let systemSetting = await CustomerOrder.fetchSystemSettings()
      context.commit('SET_SYSTEM_SETTING', systemSetting.data)
    }
    if (_.isEmpty(context.state.companyInfo)) {
      let companyInfo = await CustomerOrder.fetchCompanyInfo()
      context.commit('SET_COMPANY', companyInfo.data)
    }
    if (_.isEmpty(context.state.promotions)) {
      let promotions = await CustomerOrder.fetchPromotions()
      context.commit('SET_PROMOTIONS', promotions.data)
    }
  },
  fetchProducts(context, attributes) {
    if (!context.state.products.length > 0) {
      return CustomerOrder.product({
        params: attributes
      }).then(response => {
        context.commit('RECEIVE_PRODUCTS', response.data)
        return Promise.resolve(response)
      })
    }
    return
  },
  deleteItemOrdered(context, attributes) {
    return CustomerOrder.deleteItemOrdered({
      params: {
        stock_out_id: attributes.stock_out_id,
        product_id: attributes.product_id,
        uom_id: attributes.uom_id
      }
    }).then(response => {
      return Promise.resolve(response.data)
    })
  }
}
